<template>
  <q-layout>
    <!-- Pass drawer state and a toggle function to the NavBar and SideBar -->
    <NavBar :drawer="drawer" @toggleDrawer="drawer = !drawer" />
    <SideBar :drawer="drawer" @toggleDrawer="drawer = !drawer" />
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from 'vue'
import { QLayout, QPageContainer } from 'quasar'
import NavBar from './components/Navbar'
import SideBar from './components/Sidebar'

export default {
  name: 'App',
  components: {
    QLayout,
    QPageContainer,
    NavBar,
    SideBar
  },
  setup() {
    const drawer = ref(false);
    return { drawer };
  },
  mounted() {
    document.title = "Aims2024";
  }
}
</script>

<style>
/* Your styles here */
</style>
